import { createUseStyles } from 'react-jss';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      width: '100%',
      overflow: 'hidden',
      borderRadius: CornerRadius.r8,
      backgroundColor: BackgroundColors.base,
    },
    image: {
      position: 'relative',
      height: '100%',
      width: '100%',
      objectFit: 'cover',
      transition: 'transform 300ms',
      '.group:hover &': { transform: 'scale(1.1)' },
    },
  },
  { name: 'lazy-photo' },
);

export default useStyles;
